import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useRef } from "react";

import { FilterProps } from "./filter.types";

type FilterButtonProps = FilterProps;

const FilterButton = ({
    label,
    isSelected,
    onClick,
    className,
    children
}: FilterButtonProps) => {
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleOnClick = () => {
        buttonRef.current?.blur();

        onClick();
    };

    return (
        <Button
            ref={buttonRef}
            size={"sm"}
            color={"gray"}
            outline={!isSelected}
            onClick={handleOnClick}
            className={cn(
                "tw:text-base!",
                "tw:md:text-left",
                {
                    "tw:text-grey-dark": !isSelected,
                    "tw:border tw:border-grey-light tw:hover:border-grey-light-focus tw:focus:border-grey-light-focus":
                        isSelected
                },
                className
            )}
            title={label}
        >
            {children}
        </Button>
    );
};

export { FilterButton };
